const AboutUs = () => {
  return (
    <div id="aboutus" className="about-container">
      <div className="about-container-title">
        <h2>Sobre nosotros</h2>
      </div>
      <p className="wow animate__animated animate__zoomIn">
        "Somos una empresa con mas de 25 años de trayectoria ofreciendo
        servicios de excelencia para tu ropa. Combinamos la mejor tecnología, un
        lugar muy bien equipado y múltiples comodidades con un staff confiable y
        muy capacitado que se encargará de atender a cada una de tus
        necesidades."
      </p>
    </div>
  );
};

export default AboutUs;
